import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchStaticPages } from "../../store/actions/staticPages";
import { Style } from "react-style-tag";
import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { withRouter } from "react-router-dom";

function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
}

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export const CustomizedDialogs = ({
  open,
  handleClose,
  title,
  content,
  windowType,
}) => {
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="lg"
        fullWidth={true}
        fullScreen={windowType === 0 ? true : false}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          style={{ textAlign: "center" }}
        >
          {title}
        </DialogTitle>
        <DialogContent dividers>
          <div dangerouslySetInnerHTML={{ __html: content }}></div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

class StaticPages extends Component {
  state = {
    open: false,
    page: null,
    checkables: [],
  };
  renderTitle = (page, fpk, pages) => {
    const { language, from } = this.props;
    if (page.placement == 0 && from === "HomePage") {
      return (
        <div
          onClick={() => this.setState({ open: true, page: fpk })}
          style={{
            cursor: "pointer",
            marginBottom: 25,
            marginTop: 30,
          }}
        >
          {language == "arabic" ? page.title_ar || page.title : page.title}
        </div>
      );
    }

    if (page.placement == 2 && from === "Confirmation") {
      let classes = "";
      let styles = {};

      if (page.checkable) {
        // All Checkables
        classes += " w-100 mx-0 pb-1 px-3";
        styles = {
          ...styles,
          backgroundColor: "white",
          textAlign: language == "arabic" ? "right" : "left",
        };

        if (fpk == 0) {
          // First Checkable
          classes += " border-top pt-4";
        }

        if (
          fpk + 1 == pages.length || // Check if its a checkable and there is no more pages
          (fpk < pages.length && !pages[fpk + 1].checkable) // Or Check if its a checkable and the next item is not
        ) {
          // Therefore, Last Checkable
          classes += " border-bottom pb-4 mb-3";
          styles = {
            ...styles,
            marginBottom: 25,
          };
        }
      }
      if (!page.checkable) {
        // Not Checkables
        styles = {
          ...styles,
          marginTop: 30,
        };
      }

      return (
        <div
          className={classes}
          style={{
            display: "flex",
            flexDirection: language != "arabic" ? "row" : "row-reverse",
            ...styles,
          }}
        >
          {page.checkable && (
            <div>
              <Checkbox
                onChange={(e) => {
                  this.setCheckableStatus(fpk, e.target.checked);
                }}
                color="primary"
                inputProps={{ "aria-label": "primary checkbox" }}
              />
            </div>
          )}

          <div
            style={{
              display: "inline-block",
              flexGrow: 1,
              alignSelf: "center",
            }}
          >
            {language == "arabic" ? (
              <span>
                {page.custom_text_ar}{" "}
                <span
                  style={{
                    fontWeight: "bold",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => this.setState({ open: true, page: fpk })}
                >
                  {" "}
                  {page.title_ar || page.title}
                </span>{" "}
              </span>
            ) : (
              <span>
                {page.custom_text}{" "}
                <span
                  style={{
                    fontWeight: "bold",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => this.setState({ open: true, page: fpk })}
                >
                  {page.title}
                </span>
              </span>
            )}
          </div>
        </div>
      );
    }
  };

  componentDidMount = async () => {
    if (!this.props.settings.enable_static_pages) return;
    if (!this.props.pages.length) {
      await this.props.fetchStaticPages();
    }
    const checkablePages =
      this.props.pages?.filter((p) => p.placement === 2 && p.checkable) || [];
    if (this.props.setStaticPagesCheckableEnabled)
      this.props.setStaticPagesCheckableEnabled(checkablePages.length);
    checkablePages.forEach((p, k) => this.setCheckableStatus(k, false, true));

    if (this.props.from === "HomePage" && this.props.match?.params?.slug) {
      const pageIndex = this.props.pages.findIndex(
        (x) => slugify(x.title) === this.props.match.params.slug && !x.checkable
      );
      if (pageIndex >= 0) {
        this.setState({ open: true, page: pageIndex });
      }
    }
  };

  setCheckableStatus = (page, check, init = false) => {
    let checkables = this.state.checkables;
    checkables[page] = check;
    this.setState({ checkables });
    !init &&
      this.props.setStaticPagesCheckableChecked(
        checkables.reduce((r, c) => r && c, true)
      );
  };

  render() {
    const { pages, themeColor, language, settings, from } = this.props;
    const { open } = this.state;
    if (!settings.enable_static_pages) return <></>;
    if (!pages.length) return <></>;
    // const footerPages = pages.filter(
    //   (p) => p.placement === 0 || p.placement === 2
    // );
    const footerPages = pages;
    return (
      <>
        {footerPages
          .sort((a, b) => b.checkable - a.checkable)
          .map((footerPage, fpk, pages) => {
            const page = footerPages[this.state.page];
            return (
              <div>
                <Style>
                  {`
            .static-pages:hover {
                color: ${themeColor};
            }
          `}
                </Style>
                {this.state.page === fpk && (
                  <CustomizedDialogs
                    open={open}
                    handleClose={() => {
                      this.setState({ open: false, page: null });
                      if (
                        this.props.match?.params?.slug &&
                        this.props.from === "HomePage"
                      ) {
                        this.props.history.replace("/");
                      }
                    }}
                    title={
                      language == "arabic"
                        ? page.title_ar || page.title
                        : page.title
                    }
                    content={
                      language == "arabic"
                        ? page.content_ar || page.content
                        : page.content
                    }
                    windowType={page.window_type}
                  />
                )}
                {[0, 2].includes(footerPage.placement) && (
                  <>
                    {footerPage.checkable &&
                      fpk == 0 &&
                      from == "Confirmation" && (
                        <p
                          className="box-title"
                          style={{
                            textAlign: language === "arabic" ? "right" : "left",
                            marginTop: 30,
                          }}
                        >
                          {language == "english" ? "Confirmation" : "موافقة"}
                        </p>
                      )}
                    <p className="static-pages" style={{ color: "#777" }}>
                      {this.renderTitle(footerPage, fpk, pages)}
                    </p>
                  </>
                )}
              </div>
            );
          })}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    pages: state.staticPages.pages,
    themeColor: state.store.store.settings.dark || "#0099cc",
    settings: state.store.store.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchStaticPages: () => dispatch(fetchStaticPages()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(StaticPages));
